'use client';

import { ComponentProps, PropsWithChildren, useEffect, useRef } from 'react';
import { ChannelProvider } from './ChannelProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

interface Props
  extends PropsWithChildren,
    ComponentProps<typeof ChannelProvider> {}

const queryClient = new QueryClient();

export const RootProviders = ({ children, ...props }: Props) => {
  const players = useRef<Record<string, HTMLVideoElement | HTMLAudioElement>>(
    {},
  );
  useEffect(() => {
    const handlePlay = (e: Event) => {
      const target = e.target as HTMLVideoElement | HTMLAudioElement;
      if (!target.src) return;
      Object.entries(players.current).forEach(([src, player]) => {
        if (!player.muted && src !== target.src) {
          player.pause();
        }
      });
      players.current[target.src] = target;
    };

    document.addEventListener('play', handlePlay, true);

    return () => {
      document.removeEventListener('play', handlePlay, true);
    };
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <ChannelProvider {...props}>{children}</ChannelProvider>
    </QueryClientProvider>
  );
};
